// extracted by mini-css-extract-plugin
export var optionGrid = "_54-7";
export var optionList = "_54-6";
export var questionsBlock = "_54-9";
export var spacer = "_54-5";
export var stepCenteredContent = "_54-3";
export var stepInner = "_54-0";
export var stepInnerFullWidth = "_54-1";
export var stepInnerLockScroll = "_54-2";
export var stepTransitionFrame = "_54-4";
export var welcomeBlock = "_54-8";